import { inject } from 'vue';
import { LOCATION } from '../src/constants';
export default () => inject(LOCATION);
